import y from "../../../../public/projects/Godrej/images/projects/y.jpg";
import s from "../../../../public/projects/Godrej/images/logo/s.png";
import evergreen from "../../../../public/projects/Godrej/images/projects/ev.jpg"
import overviewImage_skygreen from "../../../../public/projects/Godrej/images/skygreen/Overview/1.webp";
import bannerDesktopImage_skygreen from "../../../../public/projects/Godrej/images/skygreen/Banner/1.webp";
import bannerMobileImage_skygreen from "../../../../public/projects/Godrej/images/skygreen/Banner/2.webp";
import siteVisitBannerImage_skygreen from "../../../../public/projects/Godrej/images/evergreen_square/SiteVisitBanner/1.webp";
import Location_skygreen from "../../../../public/projects/Godrej/images/skygreen/Location/L1.webp";
import Hightlights_skygreen from "../../../../public/projects/Godrej/images/skygreen/Highlights/1.webp";
import floorplan1_skygreen from "../../../../public/projects/Godrej/images/skygreen/floorplan/1.webp";
import floorplan2_skygreen from "../../../../public/projects/Godrej/images/skygreen/floorplan/2.webp";
import floorplan3_skygreen from "../../../../public/projects/Godrej/images/skygreen/floorplan/3.webp";
import locationicon_skygreen from "../../../../public/projects/Godrej/images/skygreen/Overview/l.png";
import calicon_skygreen from "../../../../public/projects/Godrej/images/skygreen/Overview/c.png";
import newlaunchicon_skygreen from "../../../../public/projects/Godrej/images/skygreen/Overview/n.png";
import gallery1_skygreen from "../../../../public/projects/Godrej/images/skygreen/Gallery/1.webp";
import gallery2_skygreen from "../../../../public/projects/Godrej/images/skygreen/Gallery/2.webp";
import gallery3_skygreen from "../../../../public/projects/Godrej/images/skygreen/Gallery/3.webp";
import gallery4_skygreen from "../../../../public/projects/Godrej/images/skygreen/Gallery/4.webp";
import gallery5_skygreen from "../../../../public/projects/Godrej/images/skygreen/Gallery/5.webp";


// Evergreen_Square
import overviewImage_evergreen_square from "../../../../public/projects/Godrej/images/evergreen_square/Overview/1.webp";
import bannerDesktopImage_evergreen_square from "../../../../public/projects/Godrej/images/evergreen_square/Banner/1.webp";
import bannerMobileImage_evergreen_square from "../../../../public/projects/Godrej/images/evergreen_square/Banner/2.webp";
import siteVisitBannerImage_evergreen_square from "../../../../public/projects/Godrej/images/evergreen_square/SiteVisitBanner/1.webp";
import Location_evergreen_square from "../../../../public/projects/Godrej/images/evergreen_square/Location/L1.webp";
import Hightlights_evergreen_square from "../../../../public/projects/Godrej/images/evergreen_square/Highlights/1.webp";
import floorplan1_evergreen_square from "../../../../public/projects/Godrej/images/evergreen_square/floorplan/1.webp";
import floorplan2_evergreen_square from "../../../../public/projects/Godrej/images/evergreen_square/floorplan/2.webp";
import floorplan3_evergreen_square from "../../../../public/projects/Godrej/images/evergreen_square/floorplan/3.webp";
import floorplan4_evergreen_square from "../../../../public/projects/Godrej/images/evergreen_square/floorplan/4.webp";
import floorplan5_evergreen_square from "../../../../public/projects/Godrej/images/evergreen_square/floorplan/5.webp";
import locationicon_evergreen_square from "../../../../public/projects/Godrej/images/evergreen_square/Overview/l.png";
import calicon_evergreen_square from "../../../../public/projects/Godrej/images/evergreen_square/Overview/c.png";
import newlaunchicon_evergreen_square from "../../../../public/projects/Godrej/images/evergreen_square/Overview/n.png";
// import loc from "./images/Overview/loc.png"
import gallery1_evergreen_square from "../../../../public/projects/Godrej/images/evergreen_square/Gallery/1.webp";
import gallery2_evergreen_square from "../../../../public/projects/Godrej/images/evergreen_square/Gallery/2.webp";
import gallery3_evergreen_square from "../../../../public/projects/Godrej/images/evergreen_square/Gallery/3.webp";
import gallery4_evergreen_square from "../../../../public/projects/Godrej/images/evergreen_square/Gallery/4.webp";
import gallery5_evergreen_square from "../../../../public/projects/Godrej/images/evergreen_square/Gallery/5.webp";

// riverroyale
import overviewImageriverroyale from "../../../../public/projects/Godrej/images/riverroyale/overview/1.webp";
import bannerDesktopImageriverroyale from "../../../../public/projects/Godrej/images/riverroyale/banner/1.webp";
import bannerdeveloperriverroyale from "../../../../public/projects/Godrej/images/riverroyale/banner/3.webp";
import bannerMobileImageriverroyale from "../../../../public/projects/Godrej/images/riverroyale/banner/2.webp";
import Locationriverroyale from "../../../../public/projects/Godrej/images/riverroyale/location/1.webp";
import Hightlightsriverroyale from "../../../../public/projects/Godrej/images/riverroyale/highlights/1.webp";
import floorplan1riverroyale from "../../../../public/projects/Godrej/images/riverroyale/floorplan/1.webp";
import floorplan2riverroyale from "../../../../public/projects/Godrej/images/riverroyale/floorplan/2.webp";
import floorplan3riverroyale from "../../../../public/projects/Godrej/images/riverroyale/floorplan/3.webp";
import floorplan4riverroyale from "../../../../public/projects/Godrej/images/riverroyale/floorplan/4.webp";
import floorplan5riverroyale from "../../../../public/projects/Godrej/images/riverroyale/floorplan/5.webp";
import locationiconriverroyale from "../../../../public/projects/Godrej/images/riverroyale/overview/l.png";
import caliconriverroyale from "../../../../public/projects/Godrej/images/riverroyale/overview/c.png";
import newlaunchiconriverroyale from "../../../../public/projects/Godrej/images/riverroyale/overview/n.png";
import gallery1riverroyale from "../../../../public/projects/Godrej/images/riverroyale/gallery/1.webp";
import gallery2riverroyale from "../../../../public/projects/Godrej/images/riverroyale/gallery/2.webp";
import gallery3riverroyale from "../../../../public/projects/Godrej/images/riverroyale/gallery/3.webp";
import gallery4riverroyale from "../../../../public/projects/Godrej/images/riverroyale/gallery/4.webp";
import gallery5riverroyale from "../../../../public/projects/Godrej/images/riverroyale/gallery/5.webp";
import siteVisitBannerImageriverroyale from "../../../../public/projects/Godrej/images/riverroyale/SiteVisitBanner/1.webp";

// skyline
import overviewImageskyline from "../../../../public/projects/Godrej/images/skyline/overview/1.webp";
import bannerDesktopImageskyline from "../../../../public/projects/Godrej/images/skyline/banner/1.webp";
import bannerdeveloperskyline from "../../../../public/projects/Godrej/images/skyline/banner/3.webp";
import bannerMobileImageskyline from "../../../../public/projects/Godrej/images/skyline/banner/2.webp";
import siteVisitBannerImageskyline from "../../../../public/projects/Godrej/images/skyline/SiteVisitBanner/1.webp";
import Locationskyline from "../../../../public/projects/Godrej/images/skyline/location/1.webp";
import Hightlightsskyline from "../../../../public/projects/Godrej/images/skyline/highlights/1.webp";
import floorplan1skyline from "../../../../public/projects/Godrej/images/skyline/floorplan/1.webp";
import floorplan2skyline from "../../../../public/projects/Godrej/images/skyline/floorplan/2.webp";
import floorplan3skyline from "../../../../public/projects/Godrej/images/skyline/floorplan/3.webp";
import floorplan4skyline from "../../../../public/projects/Godrej/images/skyline/floorplan/4.webp";
import floorplan5skyline from "../../../../public/projects/Godrej/images/skyline/floorplan/5.webp";
import locationiconskyline from "../../../../public/projects/Godrej/images/skyline/overview/l.png";
import caliconskyline from "../../../../public/projects/Godrej/images/skyline/overview/c.png";
import newlaunchiconskyline from "../../../../public/projects/Godrej/images/skyline/overview/n.png";
import gallery1skyline from "../../../../public/projects/Godrej/images/skyline/gallery/1.webp";
import gallery2skyline from "../../../../public/projects/Godrej/images/skyline/gallery/2.webp";
import gallery3skyline from "../../../../public/projects/Godrej/images/skyline/gallery/3.webp";
import gallery4skyline from "../../../../public/projects/Godrej/images/skyline/gallery/4.webp";
import gallery5skyline from "../../../../public/projects/Godrej/images/skyline/gallery/5.webp";

// rivercrest
import overviewImagerivercrest from "../../../../public/projects/Godrej/images/rivercrest/overview/1.webp";
import bannerDesktopImagerivercrest from "../../../../public/projects/Godrej/images/rivercrest/banner/1.webp";
import bannerdeveloperrivercrest from "../../../../public/projects/Godrej/images/rivercrest/banner/3.webp";
import bannerMobileImagerivercrest from "../../../../public/projects/Godrej/images/rivercrest/banner/2.webp";
import siteVisitBannerImagerivercrest from "../../../../public/projects/Godrej/images/rivercrest/SiteVisitBanner/1.webp";
import Locationrivercrest from "../../../../public/projects/Godrej/images/rivercrest/location/1.webp";
import Hightlightsrivercrest from "../../../../public/projects/Godrej/images/rivercrest/highlights/1.webp";
import floorplan1rivercrest from "../../../../public/projects/Godrej/images/rivercrest/floorplan/1.webp";
import floorplan2rivercrest from "../../../../public/projects/Godrej/images/rivercrest/floorplan/2.webp";
import floorplan3rivercrest from "../../../../public/projects/Godrej/images/rivercrest/floorplan/3.webp";
import floorplan4rivercrest from "../../../../public/projects/Godrej/images/rivercrest/floorplan/4.webp";
import floorplan5rivercrest from "../../../../public/projects/Godrej/images/rivercrest/floorplan/5.webp";
import locationiconrivercrest from "../../../../public/projects/Godrej/images/rivercrest/overview/l.png";
import caliconrivercrest from "../../../../public/projects/Godrej/images/rivercrest/overview/c.png";
import newlaunchiconrivercrest from "../../../../public/projects/Godrej/images/rivercrest/overview/n.png";
import gallery1rivercrest from "../../../../public/projects/Godrej/images/rivercrest/gallery/1.webp";
import gallery2rivercrest from "../../../../public/projects/Godrej/images/rivercrest/gallery/2.webp";
import gallery3rivercrest from "../../../../public/projects/Godrej/images/rivercrest/gallery/3.webp";
import gallery4rivercrest from "../../../../public/projects/Godrej/images/rivercrest/gallery/4.webp";
import gallery5rivercrest from "../../../../public/projects/Godrej/images/rivercrest/gallery/5.webp";

// emeraldwaters
import overviewImageemeraldwaters from "../../../../public/projects/Godrej/images/emeraldwaters/overview/1.webp";
import bannerDesktopImageemeraldwaters from "../../../../public/projects/Godrej/images/emeraldwaters/banner/1.webp";
import bannerMobileImageemeraldwaters from "../../../../public/projects/Godrej/images/emeraldwaters/banner/2.webp";
import Locationemeraldwaters from "../../../../public/projects/Godrej/images/emeraldwaters/location/1.webp";
import Hightlightsemeraldwaters from "../../../../public/projects/Godrej/images/emeraldwaters/highlights/1.webp";
import floorplan1emeraldwaters from "../../../../public/projects/Godrej/images/emeraldwaters/floorplan/1.webp";
import floorplan2emeraldwaters from "../../../../public/projects/Godrej/images/emeraldwaters/floorplan/2.webp";
import floorplan3emeraldwaters from "../../../../public/projects/Godrej/images/emeraldwaters/floorplan/3.webp";
import floorplan4emeraldwaters from "../../../../public/projects/Godrej/images/emeraldwaters/floorplan/4.webp";
import floorplan5emeraldwaters from "../../../../public/projects/Godrej/images/emeraldwaters/floorplan/5.webp";
import locationiconemeraldwaters from "../../../../public/projects/Godrej/images/emeraldwaters/overview/l.png";
import caliconemeraldwaters from "../../../../public/projects/Godrej/images/emeraldwaters/overview/c.png";
import newlaunchiconemeraldwaters from "../../../../public/projects/Godrej/images/emeraldwaters/overview/n.png";
import gallery1emeraldwaters from "../../../../public/projects/Godrej/images/emeraldwaters/gallery/1.webp";
import gallery2emeraldwaters from "../../../../public/projects/Godrej/images/emeraldwaters/gallery/2.webp";
import gallery3emeraldwaters from "../../../../public/projects/Godrej/images/emeraldwaters/gallery/3.webp";
import gallery4emeraldwaters from "../../../../public/projects/Godrej/images/emeraldwaters/gallery/4.webp";
import gallery5emeraldwaters from "../../../../public/projects/Godrej/images/emeraldwaters/gallery/5.webp";


export const developerGodrej = {

  properties: [
    {
      name: "Godrej Evergreen Square",
      image: evergreen,
      price: "On Request",
      state: "Pune",
      developer: "Godrej",
      projectlocation: "West Pune",
      location: "Hinjawadi, Pune",
      bed: "1 - 3 BHK ",
      size: "....",
      url: `/godrej-evergreen-square-hinjewadi-pune`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "Godrej Sky Greens ",
      image: y,
      price: "On Request",
      state: "Pune",
      developer: "Godrej",
      location: "Kharadi, Pune",
      projectlocation: "West Pune",
      bed: "1,2,3 BHK Apartments",
      size: "....",
      url: `/godrej-skygreens-kharadi-pune`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Godrej Sky Greens", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "Godrej River Crest",
      image: bannerdeveloperrivercrest,
      price: " 2 Crore Onwards",
      state: "Pune",
      developer: "Godrej",
      location: "Kharadi, Pune",
      projectlocation: "East Pune",
      bed: "3,4 BHK Apartments",
      size: "1135 - 1726 sq.ft.",
      url: `/godrej-river-crest-kharadi-pune`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Godrej River Crest",
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "Godrej Skyline",
      image: bannerdeveloperskyline,
      price: "1.6 Crore Onwards",
      state: "Pune",
      developer: "Godrej",
      location: "Mundhwa, Pune",
      projectlocation: "East Pune",
      bed: "3,4 BHK Apartments",
      size: "1348 - 2397 sq.ft.",
      url: `/godrej-skyline-mundhwa-pune`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Godrej Skyline",
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "Godrej River Royale",
      image: bannerdeveloperriverroyale,
      price: " 1.29 Crore Onwards",
      state: "Pune",
      developer: "Godrej",
      location: "Mahalunge, Pune",
      projectlocation: "West Pune",
      bed: "2,3,4 BHK Apartments",
      size: "719 - 3944 sq.ft.",
      url: `/godrej-river-royale`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Godrej River Royale",
        to_email: "jatin.rohilla@propertystation.in",
      }
    }

  ],
};
export const Headers = {
  logo: s,
  data: {
    experience: "1897",
  },
  about: `Established in 1897, the Godrej Group has its roots in India's Independence and Swadeshi movement. Our founder, Ardeshir Godrej, a lawyer-turned-serial entrepreneur failed with a few ventures before he struck gold with a locks business.

Today, we enjoy the patronage of 1.1 billion consumers globally across consumer goods, real estate, appliances, agriculture and many other businesses. In fact, our geographical footprint extends beyond Earth, with our engines now powering many of India's space missions.

With a revenue of over USD 6 billion, we are growing fast, and have exciting, ambitious aspirations. `,
};


export const projectsGodrej = {
  godrejskygreen: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_skygreen,
      bannerMobileImage: bannerMobileImage_skygreen,
      textOverlay: "",
      data: {
        title: "Godrej SkyGreen",
        subtitle: "Kharadi, Pune",
        starting_price: "On Request",
        payment_plan: "CLP",
        rerano: "P52100032428",
        status: "Under Construction"
      }
    },
    overview: {
      heading: "Discover Luxury Living at Godrej SkyGreen",
      description: [
        "Introducing Godrej Sky Greens – Your Meadow in the Sky, where nature and luxury blend seamlessly. Spread across 1 hectare of lush greenery, this unique township offers a three-tier green living experience designed for a serene and refreshing lifestyle. Elevate your everyday with an iconic sky-living concept spanning 1,500+ m², providing breathtaking views and tranquil spaces. ",
        " With 50+ world-class amenities, indulge in an extraordinary way of life filled with comfort, wellness, and recreation. Book your dream home at Godrej Sky Greens and embrace a lifestyle beyond the ordinary, where every moment is inspired by nature and elevated living.",
      ],
      image: overviewImage_evergreen_square,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationicon_skygreen,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: calicon_skygreen,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchicon_skygreen,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_skygreen,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "1 BHK ",
          area: "435 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "2 BHK ",
          area: "563 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK ",
          area: "727 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        // {
        //   type: "4 BHK",
        //   area: "1830 sq. ft.",
        //   price: "On Request*",
        //   eoiAmount: "On Request",
        // },
      ],
    },

    floor_plan: [
      {
        type: "1 BHK ",
        area: "435 sq. ft.",
        price: "On Request*",
        image: floorplan1_skygreen,
      },
      {
        type: "2 BHK ",
        area: "563 sq. ft.",
        price: "On Request*",
        image: floorplan2_skygreen,
      },
      {
        type: "3 BHK ",
        area: "727 sq. ft.",
        price: "On Request*",
        image: floorplan3_skygreen,
      },
      // {
      //   type: "4 BHK",
      //   area: "1830 sq. ft.",
      //   price: "On Request*",
      //   image: image3BHK,
      // },
    ],

    highlights: {
      images: Hightlights_skygreen,
      tagline: "Highlights",
      features: [
        "Massive clubhouse sprawled across 6500+ sq.mtrs",
        "Project offers an elevated lifestyle with an iconic sky living experience, which stretches across 1500+ sq.m.",
        "A three-tier green living that’s spread over 1 hectare of lush landscapes.",
        "Project offers 50+ lifestyle amenities.",
        "Pollution-free and open green spaces area.",
        "Strategically located in Manjari Khurd which is known for its pollution-free and open green spaces.",

      ],
    },

    location: {
      image: Location_skygreen,
      data: [
        {
          airport: {
            distance_time: "13.8 km",
            name: "Pune  Airport"
          },
          school: {
            distance_time: "1.6 Km",
            name: "HAC School"
          },
          railwayormetro: {
            distance_time: "16.1 Km",
            name: "Pune Junction"
          },
          hospital: {
            distance_time: "6.4 Km",
            name: "MS Hospital"
          },
          mall: {
            distance_time: "7.8 Km",
            name: "G Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1_skygreen },
        { image: gallery2_skygreen },
        { image: gallery3_skygreen },
        { image: gallery4_skygreen },
        { image: gallery5_skygreen },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Godrej SkyGreen, kindly share more details.",
    },

    faq: [

      {
        question: "Where is Godrej Sky Greens situated?",
        answer: `The project is situated on Kharadi-Manjari Road, Pune - 412307. This prime location offers excellent connectivity to major IT hubs, educational institutions, and entertainment centers.`,
      },
      {
        question: "What types of apartments are available at Godrej Sky Greens?",
        answer: `Godrej Sky Greens offers Studio, 1 BHK, 2 BHK, and 3 BHK apartments with carpet areas ranging from 435 sq.ft. to 727 sq.ft., catering to various family sizes and preferences.`,
      },
      {
        question: "Are there any recreational facilities in Godrej SkyGreen?",
        answer: `Yes, the project has dedicated spaces for yoga, meditation, indoor games, a sports court, and an amphitheater.`,
      },
      {
        question: "When is the expected possession date for the project?",
        answer: `The project is expected to be completed by March 2026, as per the RERA ID P52100032428.`,
      },
      {
        question: "What are some of the key amenities offered at Godrej Sky Greens?",
        answer: `The project boasts over 50 amenities, including an amphitheater, barbeque deck, cricket pitch, digital gaming room, accupressure pathway, feature play area, sky cafeteria, sky cinema, sky party deck, and a star gazing zone.`,
      },
      {
        question: "What makes Godrej Sky Greens a standout choice for homebuyers?",
        answer: `Godrej Sky Greens in Kharadi, Pune, stands out as an exceptional choice for homebuyers due to its sustainable design, premium amenities, and prime location.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, Godrej Sky Greens is RERA registered with the IDs P52100032428 and P52100032794.`,
      },
      {
        question: "What is the total area of the project?",
        answer: `The project spans over 60 hectares along the Mula-Mutha River, with over 5 hectares dedicated to greenery.`,
      },
      {
        question: "Who is the developer of Godrej Sky Greens?",
        answer: `The project is developed by Godrej Properties Limited, a renowned developer with over 30 years of experience in the real estate industry.`,
      },
      {
        question: "What are the nearby educational institutions?",
        answer: `Reputed educational institutions nearby include The Lexicon School, The Orbis School, and Symbiosis International University.`,
      },
    ],
    similar: {
      properties: [
        {
          name: "Godrej Evergreen Square",
          image: evergreen,
          price: "On Request",
          state: "Pune",
          developer: "Godrej",
          projectlocation: "West Pune",
          location: "Hinjawadi, Pune",
          bed: "1 - 3 BHK ",
          size: "....",
          url: `/godrej-evergreen-square-hinjewadi-pune`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          }
        },
        {
          name: "Godrej Sky Greens ",
          image: y,
          price: "On Request",
          state: "Pune",
          developer: "Godrej",
          location: "Kharadi, Pune",
          projectlocation: "West Pune",
          bed: "1,2,3 BHK Apartments",
          size: "....",
          url: `/godrej-skygreens-kharadi-pune`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          }
        },


      ],

    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },

  },
  godrejevergreensquare: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_evergreen_square,
      bannerMobileImage: bannerMobileImage_evergreen_square,
      textOverlay: "",
      data: {
        title: "Godrej Evergreen Square",
        subtitle: "Hinjawadi, Pune",
        starting_price: "On Request",
        payment_plan: "CLP",
        rerano: "P52100078240",
        status: "Under Construction"
      }
    },
    overview: {
      heading: "Discover Luxury Living at Godrej EverGreen Square",
      description: [
        "Godrej Hinjawadi Phase III presents premium 1, 2 & 3 BHK apartments and plots in Hinjawadi, Pune, offering an exceptional living experience. Strategically located, it provides seamless connectivity to hospitals, educational institutions, hotels, and recreation centers. With well-planned infrastructure and excellent road networks, residents enjoy effortless access to key city areas. Thoughtfully designed to meet the needs of modern homebuyers, this project blends comfort, convenience, and luxury.",
        "  At its core, the CCH philosophy fosters children’s growth through nine celebrity-led learning academies, creating a nurturing environment where they can explore their passions and thrive in a safe, inspiring",
      ],
      image: overviewImage_evergreen_square,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationicon_evergreen_square,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: calicon_evergreen_square,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchicon_evergreen_square,
          title: "Under Construction ",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_evergreen_square,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "1 BHK ",
          area: "473 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "2 BHK  ",
          area: "670 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "2 BHK ",
          area: "867 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK ",
          area: "924 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK",
          area: "1073 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "1 BHK ",
        area: "473 sq. ft.",
        price: "On Request*",
        image: floorplan1_evergreen_square,
      },
      {
        type: "2 BHK  ",
        area: "670 sq. ft.",
        price: "On Request*",
        image: floorplan2_evergreen_square,
      },
      {
        type: "2 BHK ",
        area: "867 sq. ft.",
        price: "On Request*",
        image: floorplan3_evergreen_square,
      },
      {
        type: "3 BHK ",
        area: "924 sq. ft.",
        price: "On Request*",
        image: floorplan4_evergreen_square,
      },
      {
        type: "3 BHK",
        area: "1073 sq. ft.",
        price: "On Request*",
        image: floorplan5_evergreen_square,
      },
    ],

    highlights: {
      images: Hightlights_evergreen_square,
      tagline: "Highlights",
      features: [
        "11 Acres of Gated Development.",
        "8 Towers with 32-Storey Buildings.",
        "4 Acres of Landscaping.",
        "3 Themed Gardens with Water Plaza.",
        "1 km Walking Trail.",
        "Adjacent to 45m/ 60m Road.",
        "1 Lakh sq.ft. of High Street Retail.",

      ],
    },

    location: {
      image: Location_evergreen_square,
      data: [
        {
          airport: {
            distance_time: "31.1 km",
            name: " Pune  Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "P . P School"
          },
          railwayormetro: {
            distance_time: "24 Km",
            name: " CCH  Station"
          },
          hospital: {
            distance_time: "550 M",
            name: " Vedant Hospital"
          },
          mall: {
            distance_time: "9 Km",
            name: "Xion Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1_evergreen_square },
        { image: gallery2_evergreen_square },
        { image: gallery3_evergreen_square },
        { image: gallery4_evergreen_square },
        { image: gallery5_evergreen_square },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Godrej Evergreen Square, kindly share more details.",
    },

    faq: [
      {
        question: "Where is Godrej Evergreen Square located?",
        answer: `The project is situated in Hinjewadi Phase 3, Pune.`,
      },
      {
        question: "What types of apartments are available at Godrej Evergreen Square?",
        answer: `The project offers 1, 2, and 3 BHK luxury apartments.`,
      },
      {
        question: "What are the security features at Godrej Evergreen Square?",
        answer: `The project offers 24/7 CCTV surveillance, gated access, security personnel, and smart home automation for enhanced safety.`,
      },
      {
        question: "What is the expected possession date for the project?",
        answer: `The possession is expected by October 2030. `,
      },
      {
        question: "What amenities are offered at Godrej Evergreen Square?",
        answer: `Amenities include a swimming pool, kids' play area, clubhouse, gym, garden, sports courts, multipurpose hall, and 3-tier security.`,
      },
      {
        question: "What makes Godrej Evergreen Square a standout choice for homebuyers?",
        answer: `Godrej Evergreen Square in Hinjawadi, Pune, is a standout choice for homebuyers due to its perfect blend of luxury, sustainability, and modern living.`,
      },
      {
        question: "Is the project RERA approved?",
        answer: `Yes, the project is registered with MahaRERA under registration no. P52100078240. `,
      },
      {
        question: "What is the total area of the project?",
        answer: `The project spans Over 11 acres.`,
      },
      {
        question: "What are the areas of the apartments?",
        answer: `1 BHK-473 sq. ft., 2 BHK-867 sq. ft., and 3 BHK-1073 sq. ft.`,
      },
      {
        question: "What is the address of Godrej Evergreen Square?",
        answer: `The address is Plot no. R-1/2/C, Rajiv Gandhi Infotech Park, Phase 3, Hinjawadi, Pimpri-Chinchwad, Pune, Maharashtra 411057.`,
      },
      {
        question: "Which business hubs are located nearby?",
        answer: `Nearby business hubs include Tech Mahindra (0.5 km), TCS (0.5 km), Embassy Quadron (1.7 km), and Cognizant CDC (2.9 km).`,
      },
    ],
    similar: {
      properties: [
        {
          name: "Godrej Evergreen Square",
          image: evergreen,
          price: "On Request",
          state: "Pune",
          developer: "Godrej",
          projectlocation: "West Pune",
          location: "Hinjawadi, Pune",
          bed: "1 - 3 BHK ",
          size: "....",
          url: `/godrej-evergreen-square-hinjewadi-pune`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          }
        },
        {
          name: "Godrej Sky Greens ",
          image: y,
          price: "On Request",
          state: "Pune",
          developer: "Godrej",
          location: "Kharadi, Pune",
          projectlocation: "West Pune",
          bed: "1,2,3 BHK Apartments",
          size: "....",
          url: `/godrej-skygreens-kharadi-pune`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          }
        },


      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  godrejrivercrest: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImagerivercrest,
      bannerMobileImage: bannerMobileImagerivercrest,
      textOverlay: "",
      data: {
        title: "Godrej River Crest",
        subtitle: "Godrej River Crest Kharadi, Pune",
        starting_price: "₹ 2 Crore Onwards  ",
        payment_plan: "CLP",
        rerano: "-",
        status: "New Launch"
      }
    },
    overview: {
      heading: "Discover Luxury Living at Godrej River Crest",
      description: [
        "Godrej River Crest in Kharadi, Pune, is an exclusive residential development by Godrej Properties, nestled within the expansive Godrej Integrated Township on Manjari Road. This project stands out for its blend of luxury, comfort, and connectivity, offering meticulously designed 3 and 4 BHK apartments that cater to modern urban lifestyles. Each residence is crafted to maximize space and natural light, with elegant interiors and contemporary finishes that provide a sense of sophistication and serenity. The apartments offer mesmerizing riverside views, creating a tranquil environment amidst the bustle of the city.",
        "Spread across a lush green landscape, Godrej River Crest is part of a 40.97-hectare township, with the Rivergreens sector dedicated to premium living and abundant open spaces. This project featuring amenities such as a temperature-controlled swimming pool, squash court, fitness zone, billiards, business center, multipurpose hall, and a sky lounge. The development also boasts landscaped gardens, a central park, children’s play areas, and rooftop amenities, ensuring a resort-like lifestyle for all ages.",
        "Strategically located, the project offers seamless connectivity to major IT hubs, educational institutions, healthcare centers, and retail destinations. Proximity to the Pune-Solapur Highway, Pune International Airport, and upcoming Metro lines further enhances accessibility. The township’s thoughtful design includes double-height entrance lobbies, stilt and podium parking, and advanced security features like video surveillance and 24/7 power backup. With its prime location in Kharadi, one of Pune’s most sought-after locales, Godrej River Crest provides a vibrant community atmosphere, hosting events and activities that foster connections among residents. This development promises not just a home, but a lifestyle defined by luxury, convenience, and the tranquility of nature",
      ],
      image: overviewImagerivercrest,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconrivercrest,
          title: "₹ 2 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconrivercrest,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconrivercrest,
          title: "Under Construction ",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImagerivercrest,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "1135.59 - 1492.32 sq.ft.",
          price: "₹ 2.63 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "1466.47 - 1726.33 sq.ft. ",
          price: "₹ 3.11 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "1135.59 - 1492.32 sq.ft.",
        price: "₹ 2.63 Cr",
        image: floorplan1rivercrest,
      },
      {
        type: "4 BHK  ",
        area: "1466.47 - 1726.33 sq.ft. ",
        price: "₹ 3.11 Cr",
        image: floorplan2rivercrest,
      }
    ],

    highlights: {
      images: Hightlightsrivercrest,
      tagline: "Highlights",
      features: [
        "The project provides high-end, luxurious apartments.  ",
        "Its strategic location places it close to prominent IT centers, schools, and business hubs.  ",
        "The apartments feature tranquil views and exceptional comforts.  ",
        "A range of opulent amenities is available in the clubhouse.  ",
        "Constructed using Mivan technology.  ",
      ],
    },

    location: {
      image: Locationrivercrest,
      data: [
        {
          airport: {
            distance_time: "- km",
            name: "-"
          },
          school: {
            distance_time: "- Km",
            name: "-"
          },
          railwayormetro: {
            distance_time: "- Km",
            name: "-"
          },
          hospital: {
            distance_time: "- M",
            name: "-"
          },
          mall: {
            distance_time: "- Km",
            name: "-"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1rivercrest },
        { image: gallery2rivercrest },
        { image: gallery3rivercrest },
        { image: gallery4rivercrest },
        { image: gallery5rivercrest },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Godrej River Crest, kindly share more details.",
    },

    faq: [
      {
        question: "Where is Godrej River Crest located? ",
        answer: `The project is situated in Kalyani Nagar, a prime area in Pune, near Koregaon Park.`,
      },
      {
        question: "What types of apartments are available? ",
        answer: `Godrej River Crest offers 3 BHK and 4 BHK luxury apartments.`,
      },
      {
        question: "What is the price range for apartments? ",
        answer: `Prices start from ₹2.63 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered? ",
        answer: `Yes, Godrej River Crest is RERA registered (Maharashtra RERA No: P52100023504). `,
      },
      {
        question: "What is the possession status? ",
        answer: `The project is ready-to-move-in.`,
      },
      {
        question: "Are there any nearby schools? ",
        answer: `Yes, reputed institutions like The Bishop’s School, Vibgyor High, and Symbiosis School.`,
      },
      {
        question: "What are the amenities provided at Godrej River Crest?",
        answer: `Amenities include a swimming pool, clubhouse, gym, kids’ play area, jogging track `,
      },
      {
        question: "Who is the developer of Godrej River Crest?",
        answer: ` The project is developed by Godrej Properties, one of India’s most trusted and reputed real estate developers known for quality and innovation.`,
      },
      {
        question: "How is the connectivity around Godrej River Crest?",
        answer: `Godrej River Crest offers excellent connectivity to Hadapsar, Kharadi IT Park, Pune-Solapur Highway`,
      },
      {
        question: "How can I book a flat in Godrej River Crest, Pune?",
        answer: `You can book a unit by contacting our sales team.`,
      },
    ],
    similar: {
      properties: [
        {
          name: "Godrej Evergreen Square",
          image: evergreen,
          price: "On Request",
          state: "Pune",
          developer: "Godrej",
          projectlocation: "West Pune",
          location: "Hinjawadi, Pune",
          bed: "1 - 3 BHK ",
          size: "....",
          url: `/godrej-evergreen-square-hinjewadi-pune`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          }
        },
        {
          name: "Godrej Sky Greens ",
          image: y,
          price: "On Request",
          state: "Pune",
          developer: "Godrej",
          location: "Kharadi, Pune",
          projectlocation: "West Pune",
          bed: "1,2,3 BHK Apartments",
          size: "....",
          url: `/godrej-skygreens-kharadi-pune`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          }
        },


      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  godrejskyline: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageskyline,
      bannerMobileImage: bannerMobileImageskyline,
      textOverlay: "",
      data: {
        title: "Godrej Skyline",
        subtitle: "Godrej Skyline Mundhwa, Pune",
        starting_price: "₹ 1.6 Crore Onwards",
        payment_plan: "CLP",
        rerano: "-",
        status: "New Launch"
      }
    },
    overview: {
      heading: "Discover Luxury Living at Godrej Skyline ",
      description: [
        "Godrej Skyline in Mundhwa, Pune, is a landmark residential project by Godrej Properties, set in the prestigious Koregaon Park Annexe. The development offers expansive 3 and 4 BHK apartments, with carpet areas ranging from approximately 1,500 to 2,500 sq. ft., designed to deliver an elevated living experience. The project is distinguished by its regal glass façade, which provides residents with breathtaking 360-degree panoramic views of the city, turning every window into a scenic masterpiece. Each home features wide balconies, intelligent layouts, and an impressive 11-foot floor-to-ceiling height, ensuring ample natural light, ventilation, and a sense of grandeur. The interiors are finished with premium materials such as vitrified tiles and imported marbles, reflecting a commitment to quality and sophistication.",
        "Residents enjoy an array of exclusive amenities, including a double-height glass façade clubhouse, a temperature-controlled swimming pool, a gymnasium, a multipurpose sports court, and indoor games. The project also features unique sky amenities like a 200-meter-long skywalk, a senior citizen sky court, a sunset lounge, and a star-gazing deck, offering spaces for relaxation and social gatherings. Additional facilities include a multipurpose lawn, meditation lawn, mini restaurant, and a sky party hall, catering to diverse lifestyle needs.",
        "Located on Ghorpadi-Mundhwa Road, the project provides excellent connectivity to Pune’s business hubs, entertainment zones, and educational institutions. With possession expected by July 2029, Godrej Skyline promises an unmatched combination of luxury, convenience, and architectural brilliance in one of Pune’s most coveted neighborhoods",
      ],
      image: overviewImageskyline,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconskyline,
          title: "₹ 1.6 Crore Onwards  ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconskyline,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconskyline,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImageskyline,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "1348.95 - 1586.18 sq.ft. ",
          price: "₹ 1.6 Crore Onwards",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "1807.81 - 2397.04 sq.ft. ",
          price: "₹ 3.72 Crore Onwards",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "1348.95 - 1586.18 sq.ft. ",
        price: "₹ 1.6 Crore Onwards",
        image: floorplan1skyline,
      },
      {
        type: "4 BHK  ",
        area: "1807.81 - 2397.04 sq.ft. ",
        price: "₹ 3.72 Crore Onwards",
        image: floorplan2skyline,
      }
    ],

    highlights: {
      images: Hightlightsskyline,
      tagline: "Highlights",
      features: [
        "Featuring breathtaking panoramic views  ",
        "Great access to the Mumbai-Pune Expressway and other key roadways  ",
        "The development offers a variety of lifestyle amenities    ",
        "Constructed with high-quality materials and exceptional craftsmanship   ",
        "35 + world class amenities   ",
      ],
    },

    location: {
      image: Locationskyline,
      data: [
        {
          airport: {
            distance_time: "- km",
            name: "-   "
          },
          school: {
            distance_time: "2.2 Km",
            name: "Vatsalya Public School "
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Pune Railway Station     "
          },
          hospital: {
            distance_time: "3.8 Km",
            name: "Manipal Hospital      "
          },
          mall: {
            distance_time: "3.6 Km",
            name: "Amanora Mall  "
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1skyline },
        { image: gallery2skyline },
        { image: gallery3skyline },
        { image: gallery4skyline },
        { image: gallery5skyline },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Godrej Skyline, kindly share more details.",
    },

    faq: [
      {
        question: "Where is Godrej Skyline located in Pune?",
        answer: "Godrej Skyline is strategically located in Manjri, Pune.",
      },
      {
        question: "What configurations are available at Godrej Skyline?",
        answer: "The project offers spacious 2, 3 & 4 BHK apartments.",
      },
      {
        question: "What are the key amenities at Godrej Skyline?",
        answer: "Amenities include a clubhouse, swimming pool, gymnasium, landscaped gardens.",
      },
      {
        question: "Is Godrej Skyline RERA registered?",
        answer: "Yes, Godrej Skyline is RERA registered.",
      },
      {
        question: "What makes Godrej Skyline a good investment?",
        answer: "Its prime location in East Pune, proximity to IT parks, top schools, and healthcare centers.",
      },
      {
        question: "Are there schools nearby?",
        answer: "Yes, reputed schools like The Bishop’s School, Lexicon International.",
      },
      {
        question: "Does Godrej Skyline offer eco-friendly or smart features?",
        answer: "Yes, the project incorporates green building practices, energy-efficient systems, and smart home features, reflecting Godrej’s commitment to sustainability.",
      }
    ],
    similar: {
      properties: [
        {
          name: "Godrej Evergreen Square",
          image: evergreen,
          price: "On Request",
          state: "Pune",
          developer: "Godrej",
          projectlocation: "West Pune",
          location: "Hinjawadi, Pune",
          bed: "1 - 3 BHK ",
          size: "....",
          url: `/godrej-evergreen-square-hinjewadi-pune`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          }
        },
        {
          name: "Godrej Sky Greens ",
          image: y,
          price: "On Request",
          state: "Pune",
          developer: "Godrej",
          location: "Kharadi, Pune",
          projectlocation: "West Pune",
          bed: "1,2,3 BHK Apartments",
          size: "....",
          url: `/godrej-skygreens-kharadi-pune`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          }
        },


      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  riverroyale: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageriverroyale,
      bannerMobileImage: bannerMobileImageriverroyale,
      textOverlay: "",
      data: {
        title: "Godrej River Royale",
        subtitle: "Mahalunge, Pune",
        starting_price: "₹ 1.29 Crore Onwards",
        payment_plan: "CLP",
        rerano: "--",
        status: "New Launch"
      }
    },
    overview: {
      heading: "Godrej River Royale Mahalunge, Pune",
      description: [
        "Godrej River Royale in Mahalunge, Pune, stands as a premium residential address that seamlessly blends luxury, comfort, and natural beauty. Developed by Godrej Properties, this project is spread across 4.38 acres and offers a choice of spacious 3 BHK and 4 BHK apartments, with carpet areas of approximately 1600 and 2200 square feet respectively. The development features three residential towers, each designed to maximize river views and natural light, ensuring residents enjoy a serene riverside ambiance alongside vibrant urban sophistication.",
        "The project's location in Mahalunge is a key highlight, offering excellent connectivity to major IT and business hubs such as Hinjewadi, Baner, Wakad, and Balewadi. Residents benefit from proximity to reputed schools, healthcare facilities, shopping centers, and entertainment options, making daily life convenient and hassle-free. The upcoming metro corridor and easy access to major roads further enhance its appeal for professionals and families seeking a balanced lifestyle.",
        "Godrej River Royale is distinguished by its world-class amenities, including a 31,000+ sq ft clubhouse (Club Royale), a swimming pool, sky deck, gymnasium, landscaped gardens, miniplex, kids' play area, and more. The project is adjacent to an 800-meter river promenade and offers direct access to 7.3 acres of riverfront greens, providing ample space for relaxation and recreation amidst nature.",
        "Sustainability is also a focus, with eco-friendly features such as rainwater harvesting and extensive green spaces integrated into the master plan. The apartments are thoughtfully designed with premium finishes and layouts that cater to modern needs. With its blend of regal architecture, strategic location, and the trusted legacy of Godrej Properties, Godrej River Royale emerges as a top choice for homebuyers seeking a luxurious and convenient lifestyle in Pune's rapidly developing Mahalunge locality."
      ],
      image: overviewImageriverroyale,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconriverroyale,
          title: "₹ 1.29 Crore Onwards",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconriverroyale,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconriverroyale,
          title: "New Launch",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImageriverroyale,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2 BHK",
          area: "719 - 1150 sq.ft.",
          price: "₹ 1.29 - 2.07 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK",
          area: "871 - 2828 sq.ft.",
          price: "₹ 1.29 - 4.19 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK",
          area: "2116 - 3944 sq.ft.",
          price: "₹ 3.22 - 5.99 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "2 BHK",
        area: "719 - 1150 sq.ft.",
        price: "₹ 1.29 - 2.07 Cr",
        image: floorplan1riverroyale,
      },
      {
        type: "3 BHK",
        area: "871 - 2828 sq.ft.",
        price: "₹ 1.29 - 4.19 Cr",
        image: floorplan2riverroyale,
      },
      {
        type: "4 BHK",
        area: "2116 - 3944 sq.ft.",
        price: "₹ 3.22 - 5.99 Cr",
        image: floorplan3riverroyale,
      },
    ],

    highlights: {
      images: Hightlightsriverroyale,
      tagline: "Highlights",
      features: [
        "A clubhouse covering an area of 30,000 square feet",
        "Immediate access to 7.3 acres of riverside green space",
        "Stunning vistas of an 800-meter-long river promenade",
        "Impressive views of the historic bridge and master club",
        "35+ world class amenities",
      ],
    },

    location: {
      image: Locationriverroyale,
      data: [
        {
          airport: {
            distance_time: "19 km",
            name: "Pune International Airport (PNQ)"
          },
          school: {
            distance_time: "1 Km",
            name: "Universal Wisdom School"
          },
          railwayormetro: {
            distance_time: "3 Km",
            name: "Balewadi Metro Station"
          },
          hospital: {
            distance_time: "4 Km",
            name: "Accord Multi-Speciality Hospital"
          },
          mall: {
            distance_time: "5 Km",
            name: "Xion Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1riverroyale },
        { image: gallery2riverroyale },
        { image: gallery3riverroyale },
        { image: gallery4riverroyale },
        { image: gallery5riverroyale },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Godrej River Royale, kindly share more details.",
    },

    faq: [
      {
        question: "Where is Godrej River Royale located?",
        answer: `The project is strategically located in Mahalunge, Pune.`,
      },
      {
        question: "What types of units are available in Godrej River Royale?",
        answer: `Godrej River Royale offers spacious 2, 3, and 4 BHK apartments.`,
      },
      {
        question: "Who is the developer of Godrej River Royale?",
        answer: `The project is developed by Godrej Properties.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, Godrej River Royale is RERA registered.`,
      },
      {
        question: "What makes the location of Godrej River Royale special?",
        answer: `The project's location in Mahalunge offers scenic views of the Mula River and easy access to Baner and Wakad.`,
      },
      {
        question: "Are there schools nearby?",
        answer: `Yes, several reputed schools, colleges, and healthcare facilities are located within a short drive from the project.`,
      },
      {
        question: "Are there any green or sustainable features?",
        answer: `Yes, Godrej Properties integrates eco-friendly practices like rainwater harvesting, energy-efficient lighting.`,
      },
      {
        question: "Is it a good investment opportunity?",
        answer: `Godrej River Royale is a promising investment with strong potential for future appreciation and rental demand.`,
      },
      {
        question: "How can I book an apartment in Godrej River Royale?",
        answer: `You can book your apartment by contacting our sales team.`,
      },
    ],
    similar: {
      properties: [
        {
          name: "Godrej Evergreen Square",
          image: evergreen,
          price: "On Request",
          state: "Pune",
          developer: "Godrej",
          projectlocation: "West Pune",
          location: "Hinjawadi, Pune",
          bed: "1 - 3 BHK ",
          size: "....",
          url: `/godrej-evergreen-square-hinjewadi-pune`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude",
            to_email: "jatin.rohilla@propertystation.in",
          }
        },
        {
          name: "Godrej Sky Greens ",
          image: y,
          price: "On Request",
          state: "Pune",
          developer: "Godrej",
          location: "Kharadi, Pune",
          projectlocation: "West Pune",
          bed: "1,2,3 BHK Apartments",
          size: "....",
          url: `/godrej-skygreens-kharadi-pune`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude",
            to_email: "jatin.rohilla@propertystation.in",
          }
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry",
      to_email: "leads@gurugram-property.com",
    },
  },
  emeraldwaters: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageemeraldwaters,
      bannerMobileImage: bannerMobileImageemeraldwaters,
      textOverlay: "",
      data: {
        title: "Godrej Emerald Waters",
        subtitle: "Pimpri, Pune",
        starting_price: "₹ 1.11 - 1.32 Cr Onwards",
        payment_plan: "CLP",
        rerano: "P52100051200",
        status: "Under Construction"
      }
    },

    overview: {
      heading: "Godrej Emerald Waters Pimpri Pune",
      description: [
        "Godrej Emerald Waters is a premium residential project by Godrej Properties, located in the heart of Pimpri, Pune. This development offers a range of 2, 3, and 4 BHK apartments, designed to provide a luxurious and comfortable living experience. The project is strategically situated next to Sant Tukaram Nagar Metro Station, ensuring excellent connectivity to various parts of the city.",
        "Spread across approximately 9.61 acres, Godrej Emerald Waters comprises seven towers with 32 floors each, housing a total of 1,154 units. The apartments are thoughtfully designed with carpet areas ranging from 681.14 - 809.55 sq.ft. for 2 BHK units, and up to 886.62 sq. ft. for 3 BHK configurations.",
       ],
      keywordLinks: {
        
      },
      image: overviewImageemeraldwaters,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconemeraldwaters,
          title: "₹ 1.11 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconemeraldwaters,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconemeraldwaters,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK",
          area: "1209.65 - 1584.03 sq.ft.",
          price: "₹ 1.11 - 1.32 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK",
          area: "1640.53 - 2901.76 sq.ft.",
          price: "₹ 1.23 Cr",
          eoiAmount: "Onwards",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK",
          area: "1209.65 - 1584.03 sq.ft.",
          price: "₹ 1.11 - 1.32 Cr",
        image: floorplan1emeraldwaters,
      },
      {
        type: "4 BHK",
        area: "1640.53 - 2901.76 sq.ft.",
        price: "₹ 1.23 Cr",
        image: floorplan2emeraldwaters,
      }
    ],

    highlights: {
      images: Hightlightsemeraldwaters,
      tagline: "Highlights",
      features: [
        "Located bang on Old Pune - Pune Highway and Opp. to Santukaram Metro station",
        "Approx. 21,000+ sq.ft of Aqua theme based clubhouse",
        "2 acres of podium amenities and 1 acre of reserve green along with infinity swimming pool",
        "Noise reduction windows",
        "4-in-1 digital main door lock",
      ],
    },

    location: {
      image: Locationemeraldwaters,
      data: [
        {
          airport: {
            distance_time: "17.8 km",
            name: "Pune International Airport"
          },
          school: {
            distance_time: "1.6 km",
            name: "Dr. D. Y. Patil Institute of Technology"
          },
          railwayormetro: {
            distance_time: "15.4 km",
            name: "Pune Railway Station"
          },
          hospital: {
            distance_time: "2.7 km",
            name: "Yashwantrao Chavan Memorial Hospital"
          },
          mall: {
            distance_time: "4.5 km",
            name: "Elpro City Square"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1emeraldwaters },
        { image: gallery2emeraldwaters },
        { image: gallery3emeraldwaters },
        { image: gallery4emeraldwaters },
        { image: gallery5emeraldwaters },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Godrej Emerald Waters, kindly share more details.",
    },

    faq: [
      {
        question: "Where is Godrej Emerald Waters located?",
        answer: "The project is located in Pimpri, Pune, next to Sant Tukaram Nagar Metro Station, offering excellent connectivity to various parts of the city.",
      },
      {
        question: "What configurations are available at Godrej Emerald Waters?",
        answer: "The project offers 2 BHK, 3 BHK, and 4 BHK apartments.",
      },
      {
        question: "What is the starting price of apartments in Godrej Emerald Waters?",
        answer: "Prices start from ₹1.11 crore for a 3 BHK apartment and ₹1.23 crore for a 4 BHK.",
      },
      {
        question: "Is Godrej Emerald Waters RERA registered?",
        answer: "Yes, the project is RERA registered with the number P52100051200.",
      },
      {
        question: "When is the possession date for Godrej Emerald Waters?",
        answer: "The possession of the apartments is expected by March 2028.",
      },
      {
        question: "How many towers and units are there in the project?",
        answer: "Godrej Emerald Waters comprises seven towers with 32 floors each, housing a total of 1,154 units.",
      },
      {
        question: "What is the total area of the project?",
        answer: "The project is spread over approximately 9.61 acres.",
      },
      {
        question: "What are the nearby landmarks and connectivity options?",
        answer: "The project offers proximity to key landmarks such as Pimpri Chowk and Pimpri Railway Station, with excellent connectivity to major parts of Pune.",
      },
      {
        question: "Who is the developer of Godrej Emerald Waters?",
        answer: "Godrej Emerald Waters is developed by Godrej Properties.",
      },
      {
        question: "Is Godrej Emerald Waters a good investment option?",
        answer: "Absolutely. With its prime location, luxurious features, and the trusted brand of Godrej Properties, it presents an excellent investment opportunity.",
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
};
